import service from './api.services';

const buscarInfoMapa = async (Area, CodImovel) => {
    const response = await service.get(`/api/mapa/${Area}/${CodImovel}`);
    return response.data.dados;
};

export { buscarInfoMapa };
('');
